import { ScaleDefinition } from '../../models/dynamic-scale.model';
import { SCALE_TYPE } from '../scale-type.enum';

export const IPAQ_SCALE: ScaleDefinition = {
  idRef: SCALE_TYPE.IPAQ,
  title: 'IPAQ – International Physical Activity Questionnaire (Short Form)',
  scoreConfig: {
    scoreKey: 'totale_met',
    scoreFields: ['met_camminata', 'met_moderata', 'met_vigorosa'],
  },
  sections: [
    {
      name: 'ipaq',
      label: 'IPAQ – Short Form',
      fields: [
        // CAMMINATA
        {
          key: 'camminata_giorni',
          label: 'Giorni di camminata a passo sostenuto',
          type: 'number',
          min: 0,
          max: 7,
          maxScore: 7,
          step: 1,
          description:
            'Numero di giorni a settimana in cui il soggetto cammina almeno 10 minuti consecutivi.',
        },
        {
          key: 'camminata_minuti',
          label: 'Minuti di camminata al giorno',
          type: 'number',
          min: 0,
          max: 300,
          maxScore: 300,
          step: 1,
          description:
            'Minuti medi di camminata a passo sostenuto in ciascun giorno attivo.',
        },
        // ATTIVITÀ MODERATA
        {
          key: 'moderata_giorni',
          label: 'Giorni di attività moderata',
          type: 'number',
          min: 0,
          max: 7,
          maxScore: 7,
          step: 1,
          description:
            'Esempi: pedalare leggero, giardinaggio, camminata veloce.',
        },
        {
          key: 'moderata_minuti',
          label: 'Minuti di attività moderata al giorno',
          type: 'number',
          min: 0,
          max: 300,
          maxScore: 300,
          step: 1,
          description: 'Minuti medi dedicati alle attività fisiche moderate.',
        },
        // ATTIVITÀ VIGOROSA
        {
          key: 'vigorosa_giorni',
          label: 'Giorni di attività vigorosa',
          type: 'number',
          min: 0,
          max: 7,
          maxScore: 7,
          step: 1,
          description: 'Esempi: corsa, sport intensi, aerobica.',
        },
        {
          key: 'vigorosa_minuti',
          label: 'Minuti di attività vigorosa al giorno',
          type: 'number',
          min: 0,
          max: 300,
          maxScore: 300,
          step: 1,
          description: 'Minuti medi dedicati ad attività fisiche vigorose.',
        },
        // SEDENTARIETÀ
        {
          key: 'seduti_minuti',
          label: 'Minuti trascorsi seduti (giorno tipico)',
          type: 'number',
          min: 0,
          max: 1000,
          maxScore: 1000,
          step: 1,
          description: 'Tempo totale trascorso seduti in un giorno medio.',
        },
      ],
    },
  ],

  computedFields: [
    {
      key: 'met_camminata',
      label: 'MET – Camminata',
      type: 'number',
      calculation: 'camminata_giorni * camminata_minuti * 3.3',
      maxScore: null,
    },
    {
      key: 'met_moderata',
      label: 'MET – Attività moderata',
      type: 'number',
      calculation: 'moderata_giorni * moderata_minuti * 4.0',
      maxScore: null,
    },
    {
      key: 'met_vigorosa',
      label: 'MET – Attività vigorosa',
      type: 'number',
      calculation: 'vigorosa_giorni * vigorosa_minuti * 8.0',
      maxScore: null,
    },
    {
      key: 'totale_met',
      label: 'Totale MET-min/settimana',
      type: 'number',
      calculation: 'SUM(scoreConfig.sumOf)',
      maxScore: null,
    },
    {
      key: 'interpretazione',
      label: 'Livello di attività fisica',
      type: 'text',
      calculation: `
        IF(totale_met >= 3000, "High activity",
          IF(totale_met >= 600, "Moderate activity",
            "Low activity"
          )
        )
      `,
      maxScore: null,
    },
  ],
};
